import { useEffect, useState } from "react";
import * as uuid from "uuid";
import styles from "../../../../../../styles/add-product.module.scss";
import { Button } from "../../../../../components/Button";
import { Checkbox } from "../../../../../components/Checkbox";
import { CurrencyInput } from "../../../../../components/CurrencyInput";
import { Drawer } from "../../../../../components/Drawer";
import { Hairline } from "../../../../../components/Hairline";
import { Input } from "../../../../../components/Input";
import { Label } from "../../../../../components/Label";
import { Message } from "../../../../../components/Message";
import { Radio } from "../../../../../components/Radio";
import { Select } from "../../../../../components/Select";
import { Textarea } from "../../../../../components/Textarea";
import { If } from "../../../../../components/control-statements/If";
import { Icon } from "../../../../../components/core/Icon";

import { AssetsAPI } from "../../../../../../providers/AssetsAPI";
import { NumberInput } from "../../../../../components/NumberInput";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import Toggle2 from "shared/components/Toggle2";
import classNames from "classnames/bind";
import { Add } from "shared/components/Add";
const css = classNames.bind(styles);

const getEmptyQuestion = (empty) => ({
  ref_id: uuid.v4(),
  name: empty ? "Nova etapa" : "",
  type: "question",
  items: [],
});

const getTotalCharacters = (product) => {
  return `${product.sku?.length > 0 ? product.sku?.length : 0}/60`;
};

const OptionItem = ({
  option,
  optionIndex,
  onChange,
  onDelete,
  handleOptionSteps,
  allowInfiniteSublevels,
}) => {
  const [useDescription, setUseDescription] = useState(option.description);

  useEffect(() => {
    if (!useDescription) onChange({ ...option, description: null });
  }, [useDescription]);

  const handleImage = async (e) => {
    const image = await handleSetImage(e);

    if (image) onChange({ ...option, image });
  };

  const handleSetImage = async (e) => {
    return new Promise((resolve) => {
      const file = e.target.files[0];

      if (file) {
        const maxFileSize = 1;
        const fileSize = file.size / 1024 / 1024;
        const fileType = file.type;

        if (fileSize > maxFileSize) {
          alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
          return resolve(false);
        }

        const pattern = /image-*/;

        if (!fileType.match(pattern)) {
          alert({ text: "Arquivo inválido." });

          return resolve(false);
        }

        let reader = new FileReader();
        reader.onload = async (readerEvent) => {
          const response = await AssetsAPI.PostAssets({
            mime_type: fileType,
            file: readerEvent.target.result.split("base64,")[1],
          });

          const image = response.getData(null);
          return resolve(image);
        };

        reader.readAsDataURL(file);
      }

      e.target.value = null;
    });
  };

  return (
    <div className={styles.optionItem}>
      <div className="d-flex align-center mb-15">
        <label className={styles.picture} htmlFor={option.id}>
          <input
            type="file"
            id={option.id}
            accept="image/*"
            onChange={handleImage}
          />
          {option.image ? (
            <img
              src={`${process.env.REACT_APP_ASSETS_URL}/${option.image}`}
              alt=""
            />
          ) : (
            <>
              <Icon name="image" light />
              <span className={styles.plus}>
                <Icon name="plus" size="xs" />
              </span>
            </>
          )}
        </label>
        <Input
          design="two"
          className="w-100 ml-15"
          defaultValue={option.name}
          onChange={(e) => {
            onChange({ ...option, name: e.target.value });
          }}
        />
        <Button
          design="default-icon"
          className="ml-15"
          onClick={() => onDelete(option, optionIndex)}
        >
          <Icon name="trash" light size="xl" />
        </Button>
      </div>

      {useDescription && (
        <Textarea
          design="three"
          placeholder="Descrição"
          value={option.description}
          minHeight={100}
          onChange={(e) => {
            onChange({ ...option, description: e.target.value });
          }}
        />
      )}

      <Input
        label="Código SKU"
        design="three"
        placeholder="----"
        className="mt-15"
        maxLength={60}
        suffix2={getTotalCharacters(option)}
        value={option.sku}
        onChange={(e) => onChange({ ...option, sku: e.target.value })}
      />

      <div className="d-flex align-center mt-25">
        {!option?.promo_price && (
          <CurrencyInput
            design="three"
            value={option.price}
            onChange={(e, m, f) => {
              onChange({ ...option, price: f });
            }}
            placeholder="R$ 0,00"
            className="w-100"
            label="Preço"
          />
        )}
        {!!option?.promo_price && (
          <>
            <CurrencyInput
              design="three"
              value={option.old_price || option.price}
              onChange={(e, m, f) => {
                onChange({ ...option, old_price: f });
              }}
              placeholder="R$ 0,00"
              className="w-100"
              label="Preço inicial"
            />
            <CurrencyInput
              design="three"
              value={option.price}
              onChange={(e, m, f) => onChange({ ...option, price: f })}
              placeholder="R$ 0,00"
              className="w-100 ml-15"
              label="Preço promocional"
            />
          </>
        )}
      </div>

      <Hairline className="mt-15 mb-15" />

      <Checkbox
        checked={useDescription}
        className="mb-10"
        design="two"
        onChange={() => setUseDescription(!useDescription)}
      >
        Utilizar descrição
      </Checkbox>
      <Checkbox
        checked={!!option.promo_price}
        design="two"
        onChange={(e) =>
          onChange({
            ...option,
            promo_price: e,
            old_price: !e ? null : option.price,
            price: !e ? option.old_price : option.price,
          })
        }
      >
        Utilizar promoção
      </Checkbox>

      
        <Button onClick={() => handleOptionSteps(option)} className="mt-10">
          Adicionar etapas
        </Button>
      
    </div>
  );
};

const QuestionItem = ({
  mode,
  question,
  onEditMode,
  onDelete,
  onUpPosition,
  onDownPosition,
  currentPosition,
  totalItems,
}) => {
  return (
    <>
      <If cond={mode == "sort"}>
        <div className="mb-15 d-flex">
          <div className={`${styles.stepName} flex-1`}>{question.name}</div>
          <Button
            design="default-icon"
            disabled={currentPosition == 0}
            onClick={() => onUpPosition(question)}
          >
            <Icon name="chevron-up" size="1x" />
          </Button>
          <Button
            design="default-icon"
            disabled={currentPosition == totalItems - 1}
            onClick={() => onDownPosition(question)}
            className="ml-5"
          >
            <Icon name="chevron-down" size="1x" />
          </Button>
        </div>
      </If>

      <If cond={mode == "show"}>
        <div className="mb-15 d-flex">
          <div className={`${styles.stepName} flex-1`}>{question.name}</div>
          <Button design="default-icon" onClick={() => onEditMode(question)}>
            <Icon name="pen" size="xl" />
          </Button>
          <Button
            design="default-icon"
            className="ml-5"
            onClick={() => onDelete(question)}
          >
            <Icon name="trash" size="xl" />
          </Button>
        </div>
      </If>
    </>
  );
};

const Answers = ({
  question,
  catalog,
  onChange,
  onChangeQuestion,
  onDiscardQuestion,
  handleOptionSteps,
  onClose,
}) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(
    catalog.items[0]?.id || null
  );
  const [holdingId, setHoldingId] = useState(null);
  const [isRequired, setIsRequired] = useState(true);

  const [answerType, setAnswerType] = useState(
    question.items.length > 0 ? "withText" : null
  );
  const [tempQuestion, setTempQuestion] = useState({
    ...question,
    min: question.min || 0,
    max: question.max || 0,
  });

  const loadEnvironment = async () => {
    setHoldingId(await EnvironmentStorage.getEnvironmentHoldingId());
  };

  useEffect(() => {
    loadEnvironment();
  }, []);

  const allowInfiniteSublevels = holdingId === 819;

  useEffect(() => {
    if (question.min > 0) setIsRequired(true);
    else setIsRequired(false);
  }, [question]);

  return (
    <div className={styles.scrollContainer}>
      <Input
        label="Pergunta"
        design="two"
        className="mb-15"
        placeholder="Ex. Deseja por molho?"
        defaultValue={tempQuestion.name}
        onChange={(e) =>
          setTempQuestion((question) => ({
            ...question,
            name: e.target.value,
          }))
        }
      />

      <div className={styles.minMax}>
        <Label>Obrigatoriedade das respostas</Label>
        <Hairline className="mt-10 mb-15" />
        <Radio
          family="required"
          className="mb-10"
          value={true}
          checked={isRequired}
          onChange={() => {
            setTempQuestion((question) => ({
              ...question,
              min: 1,
              max: question.max >= 1 ? question.max : 1,
            }));
            setIsRequired(true);
          }}
        >
          Obrigatório
        </Radio>
        <Radio
          family="required"
          value={false}
          checked={isRequired}
          onChange={() => {
            setTempQuestion((question) => ({
              ...question,
              min: 0,
              max: question.max >= 0 ? question.max : 0,
            }));
            setIsRequired(false);
          }}
        >
          Opcional
        </Radio>
        <div className={styles.spinners}>
          <div className="d-flex flex-column flex-1">
            <Label>Mínimo de opções</Label>
            <div className={styles.quantitySpinner}>
              <div
                className={css({
                  minus: true,
                  disabled: isRequired
                    ? tempQuestion.min === 1
                    : tempQuestion.min === 0,
                })}
                onClick={() =>
                  setTempQuestion((question) => ({
                    ...question,
                    min: question.min - 1,
                  }))
                }
              >
                <i className="far fa-minus" />
              </div>

              <p className={styles.quantity}>{tempQuestion.min}</p>

              <div
                className={styles.plus}
                onClick={() =>
                  setTempQuestion((question) => ({
                    ...question,
                    min: question.min + 1,
                    max: question.min + 1,
                  }))
                }
              >
                <i className="far fa-plus" />
              </div>
            </div>
          </div>
          <div className="d-flex flex-column flex-1">
            <Label>Máximo de opções</Label>
            <div className={styles.quantitySpinner}>
              <div
                className={css({
                  minus: true,
                  disabled:
                    (isRequired
                      ? tempQuestion.max === 1
                      : tempQuestion.max === 0) ||
                    tempQuestion.max <= tempQuestion.min,
                })}
                onClick={() =>
                  setTempQuestion((question) => ({
                    ...question,
                    max: question.max - 1,
                  }))
                }
              >
                <i className="far fa-minus" />
              </div>

              <p className={styles.quantity}>{tempQuestion.max}</p>

              <div
                className={styles.plus}
                onClick={() =>
                  setTempQuestion((question) => ({
                    ...question,
                    max: question.max + 1,
                  }))
                }
              >
                <i className="far fa-plus" />
              </div>
            </div>
          </div>
        </div>

        <Hairline className="mt-15 mb-15" />

        <Toggle2
          title="Permitir várias seleções de um mesmo item"
          checked={tempQuestion.mode == "quantity"}
          reverse
          onChange={() =>
            setTempQuestion((question) => ({
              ...question,
              mode: question.mode === "quantity" ? "option" : "quantity",
            }))
          }
        />
      </div>

      <Hairline className="mt-20 mb-20" />
      <Label>Respostas</Label>

      <If cond={answerType === "withText"}>
        {tempQuestion.items.map((option, optionIndex) => (
          <OptionItem
            option={option}
            question={question}
            key={`option-${option.ref_id}`}
            optionIndex={optionIndex}
            onChange={(option) => {
              tempQuestion.items[optionIndex] = option;

              setTempQuestion((question) => ({
                ...question,
                ...tempQuestion,
              }));
            }}
            onDelete={(option, oIndex) => {
              let tempItems = tempQuestion.items;
              tempItems = tempQuestion.items.filter((o, oIdx) => {
                return oIdx !== oIndex;
              });

              setTempQuestion((question) => ({
                ...question,
                items: tempItems,
              }));
              if (tempQuestion.items.length == 0) {
                setAnswerType(null);
              }
            }}
            handleOptionSteps={(option) => handleOptionSteps(option)}
            allowInfiniteSublevels={allowInfiniteSublevels}
          />
        ))}
        <Button
          design="default-2"
          className="w-100"
          onClick={() => {
            tempQuestion.items.push({
              ref_id: uuid.v4(),
              type: "option",
              name: "",
              price: 0,
            });
            setTempQuestion((question) => ({
              ...question,
              ...tempQuestion,
            }));
          }}
        >
          Adicionar resposta em texto
        </Button>
      </If>
      <If cond={answerType === "withProducts"}>
        <Message>
          Este método simplesmente copia o nome dos produtos para as respostas,
          desta forma não há vinculo nenhum entre os dois elementos. Logo, caso
          hajam alterações no produto copiado, será necessário replicar essas
          alterações aqui.
        </Message>
        <Select
          design="two"
          className="flex-1 mt-20"
          label="Selecione o produto"
          value={selectedCategoryId}
          options={catalog.items.map((e) => ({ value: e.id, label: e.name }))}
          onChange={(e) => setSelectedCategoryId(e.target.value)}
        />
        <Button
          design="default-2"
          className="w-100 mt-20"
          disabled={!selectedCategoryId}
          onClick={() => {
            const selectedCategory = catalog.items.find(
              (c) => c.id == selectedCategoryId
            );
            if (selectedCategory) {
              const q = {
                ...tempQuestion,
                items: selectedCategory.items.map((p) => ({
                  parent: tempQuestion.id ? tempQuestion.id : null,
                  ref_id: uuid.v4(),
                  type: "option",
                  name: p.name,
                  price: null,
                })),
              };
              setTempQuestion(q);
              setAnswerType("withText");
            }
          }}
        >
          Adicionar respostas com produto
        </Button>
      </If>

      <If cond={answerType == null}>
        <div className={styles.addAnswer}>
          <Button
            design="default-2"
            className="w-100"
            onClick={() => {
              question.items.push({
                ref_id: uuid.v4(),
                type: "option",
                name: "",
                price: 0,
              });
              if (question.id) {
                question.items.forEach((o) => {
                  o.parent = question.id;
                });
              }

              onChange(question);
              setAnswerType("withText");
            }}
          >
            Resposta em texto
          </Button>
          <Button
            design="default-2"
            className="w-100 mt-15"
            onClick={() => setAnswerType("withProducts")}
          >
            Resposta com produtos
          </Button>
        </div>
      </If>

      <div className={styles.footerColumn}>
        <Button
          design="primary"
          className="w-100"
          onClick={() => {
            onChangeQuestion(tempQuestion);
            onClose();
          }}
          disabled={
            tempQuestion.items.find((q) => !q.name) ||
            !tempQuestion.name ||
            tempQuestion.items.length === 0
          }
        >
          Salvar alterações
        </Button>
        <Button
          className="w-100 mt-15"
          onClick={() => {
            onClose();
            // onDiscardQuestion();
          }}
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
};

export const OptionStepQuestion = ({
  catalog,
  product,
  onChange,
  option,
  handleOptionSteps,
}) => {
  const [editMode, setEditMode] = useState(-1);
  const [sortMode, setSort] = useState(false);
  const [openAnswers, setOpenAnswers] = useState(false);
  const [questionToEditAnswers, setTempQuestionToEditAnswers] = useState(null);
  const [questioIndex, setTempQuestionIndex] = useState(null);

  const handler = (e) => {
    onChange({ items: e });
  };

  const findOptionByRefId = (items, refId) => {
    if (!items) return null;
    for (const item of items) {
      if (item.ref_id === refId) return item;

      if (item.items) {
        const found = findOptionByRefId(item.items, refId);
        if (found) return found;
      }
    }
    return null;
  };

  const selectedOption =
    findOptionByRefId(product?.items, option?.ref_id) || {};

  if (!selectedOption.items) selectedOption.items = [];

  const onDeleteQuestion = (questionIndex) => {
    handler(selectedOption.items.filter((e, eIdx) => eIdx != questionIndex));
  };

  return (
    <>
      <p className={styles.selectedOption}>{selectedOption.name}</p>
      <Label>Esta opção possui etapas?</Label>
      <Radio
        family="has-questions"
        value={false}
        checked={selectedOption.items.length > 0}
        className="mb-15"
        onChange={() => handler([])}
      >
        Não
      </Radio>
      <Radio
        family="has-questions"
        value={true}
        checked={selectedOption.items.length > 0}
        onChange={() => {
          const newQuestions = [getEmptyQuestion(true)];
          handler(newQuestions);
        }}
      >
        Sim
      </Radio>

      {selectedOption.items.length > 0 && (
        <>
          <Hairline />
          <div className={styles.container}>
            <div className="d-flex align-center justify-between relative">
              <If cond={!sortMode}>
                <Label className="mb-0">
                  Configure as etapas deste produto (
                  {selectedOption.items.length})
                </Label>
              </If>
              <If cond={sortMode}>
                <Label className="mb-0">
                  Ordenar etapas ({selectedOption.items.length})
                </Label>
              </If>

              <div className="d-flex align-stretch gap-10">
                <If cond={sortMode}>
                  <Button design="default-3" onClick={() => setSort(false)}>
                    Salvar ordenação
                  </Button>
                </If>
                {selectedOption.items.length > 1 && (
                  <Button
                    design="default-icon"
                    onClick={() => setSort(!sortMode)}
                  >
                    <Icon name="sort-size-up-alt" size="lg" />
                  </Button>
                )}
              </div>
            </div>

            <Hairline className="mt-15 mb-15" />

            {selectedOption.items.map((questionItem, qIdx, questions) => {
              return (
                <QuestionItem
                  key={`question-item-${questionItem.ref_id}`}
                  mode={sortMode ? "sort" : editMode === qIdx ? "edit" : "show"}
                  catalog={catalog}
                  question={questionItem}
                  currentPosition={qIdx}
                  totalItems={questions.length}
                  onUpPosition={() => {
                    const upOption = questions[qIdx - 1];
                    questions[qIdx - 1] = { ...questionItem };
                    questions[qIdx] = { ...upOption };
                    handler(questions);
                  }}
                  onDownPosition={() => {
                    const downOption = questions[qIdx + 1];
                    questions[qIdx + 1] = { ...questionItem };
                    questions[qIdx] = { ...downOption };
                    handler(questions);
                  }}
                  onEditMode={(question) => {
                    setTempQuestionToEditAnswers(question);
                    setTempQuestionIndex(qIdx);
                    setOpenAnswers(true);
                  }}
                  onChange={(newQuestion) => {
                    questions[qIdx] = newQuestion;
                    handler(questions);
                  }}
                  onDelete={() => onDeleteQuestion(qIdx)}
                  visible={openAnswers}
                />
              );
            })}

            {editMode > -1 && (
              <div className="d-flex w-100 mt-20">
                <Button
                  design="primary"
                  className="flex-1"
                  onClick={() => setEditMode(-1)}
                >
                  Confirmar
                </Button>
                <Button
                  design="default-icon"
                  onClick={() => onDeleteQuestion(editMode)}
                  className="ml-10"
                >
                  <Icon name="trash-alt" size="lg" />
                </Button>
              </div>
            )}
            {editMode === -1 && !sortMode && (
              <div className="d-flex w-100">
                <Add
                  text="Adicionar etapa"
                  className="d-flex flex-column"
                  onClick={() => {
                    const newQuestions = [
                      ...selectedOption.items,
                      getEmptyQuestion(),
                    ];
                    setTempQuestionIndex(newQuestions.length - 1);
                    setTempQuestionToEditAnswers(
                      newQuestions[newQuestions.length - 1]
                    );
                    setOpenAnswers(true);
                    // handler(newQuestions);
                  }}
                >
                  Adicionar etapa
                </Add>
              </div>
            )}
          </div>
        </>
      )}

      <Drawer
        visible={openAnswers}
        title="Etapas"
        // subtitle={selectedOption.name}
        showBackButton
        onClose={() => setOpenAnswers(false)}
        alreadyDrawer
        withoutTransition
      >
        <Answers
          question={questionToEditAnswers}
          catalog={catalog}
          onChange={(option) => {
            const items = selectedOption.items.map((sItem) => {
              return sItem;
            });
            onChange({ ...items, option });
          }}
          onChangeQuestion={(newQuestion) => {
            const questions = selectedOption.items;
            questions[questioIndex] = newQuestion;
            setTempQuestionToEditAnswers(newQuestion);

            handler(questions);
          }}
          onDiscardQuestion={() => {
            const questions = selectedOption.items.slice(
              0,
              selectedOption.items.length - 1
            );

            handler(questions);
            setOpenAnswers(false);
          }}
          onDelete={(question, oIndex) => {
            question.items = question.items.filter((o, oIdx) => {
              return oIdx !== oIndex;
            });

            onChange(question);
          }}
          onClose={() => setOpenAnswers(false)}
          handleOptionSteps={(option) => {
            handleOptionSteps(option);
            setOpenAnswers(false);
          }}
        />
      </Drawer>
    </>
  );
};
